export const store = {
    data: {
        wrongPass : false,
        apiUrl: 'https://api.ci.beneschu.de/index.php/api',
        password: '',
        username: 'standard',
        currentVidId: null,
        currentVidTitle: ''
    },
}


// WEBPACK FOOTER //
// ./src/store.js